import { Suspense } from "react";
import { useAtomValue } from "jotai";
import pluralize from "pluralize";
import {
  hasZslAtom,
  showZapRunsAtom,
  zapUsageAsyncAtomFamily,
} from "@zapier/canvas-state";
import { Icon, Text, TooltipWrapper } from "@zapier/design-system";

import styles from "./ZapMetrics.module.css";

type Props = {
  zapId: string | undefined;
  isPublished: boolean | undefined;
};

const size = 18;

export function ZapMetrics({ zapId, isPublished }: Props) {
  const hasZsl = useAtomValue(hasZslAtom);
  const showZapRuns = useAtomValue(showZapRunsAtom);

  if (!zapId || hasZsl || !showZapRuns || !isPublished) return null;

  return (
    <Suspense fallback={null}>
      <SuspendedZapMetrics zapId={zapId} />
    </Suspense>
  );
}

function SuspendedZapMetrics({ zapId }: { zapId: string }) {
  const usage = useAtomValue(zapUsageAsyncAtomFamily(zapId));

  // When user has no access to the zap
  if (usage === null) {
    return null;
  }

  return (
    <TooltipWrapper position="north" content="Last 30 days">
      {() => (
        <span className={styles.contentWrapper}>
          <Icon name="actionPlayFill" size={size} color="TextWeaker" />
          <Text type="MinimalPrint2" color="TextWeaker">
            {`${usage.success.toLocaleString()} ${pluralize("run", usage.success)}`}
          </Text>
        </span>
      )}
    </TooltipWrapper>
  );
}
